/**
 * Created by Mateusz Janeczek.
 */
import React from 'react';
import { Tooltip } from 'react-bootstrap';
import { connect } from 'react-redux';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import MenuIcon from '../../MapNav/MenuIcon';
import s from '../../MapHeader/MapHeader.scss';
import s1 from './MeasureTools.scss';
import iconLinia from './icons/linia.png';
import iconPowierzchnia from './icons/powierzchnia.png';
import iconPunkt from './icons/punkt.png';


import { disableMeasurementTool, setMeasurementTool } from '../../../actions/mapTools';

class MeasureTools extends React.Component {
  constructor(props) {
    super(props);
  }

  startTool = (type) => {
    if (this.props.tools.currentTool) {
      this.disableTool();
    } else {
      this.props.setMeasurementTool(type);
    }
  }

  disableTool = () => {
    this.props.disableMeasurementTool();
  }

  render() {
    let getPoint = (this.props.tools.isMeasuring == true && this.props.tools.currentTool === 'getPoint') ? 'pulse-li': null;
    let measurePolyLine = (this.props.tools.isMeasuring == true && this.props.tools.currentTool === 'measurePolyLine') ? 'pulse-li': null;
    let measurePolygon = (this.props.tools.isMeasuring == true && this.props.tools.currentTool === 'measurePolygon') ? 'pulse-li': null;

    return (
      <div className={'absolute-popup'}>
        <ul className={'measure-nav-list'}>
          <MenuIcon
            overlay={<Tooltip id="tooltip"><strong>{this.props.intl.langKeys.punkt}</strong><br/>{this.props.intl.langKeys.wezPunkt}</Tooltip>}
            textPlacement="bottom"
            actionOnClick={() => this.startTool('getPoint')}
            iconStyling={"icon"}
            liClass={getPoint}
            src={iconPunkt}
          />
          <MenuIcon
            overlay={<Tooltip id="tooltip"><strong>{this.props.intl.langKeys.linia}</strong><br/>{this.props.intl.langKeys.wykonajPomiar}</Tooltip>}
            textPlacement="bottom"
            actionOnClick={() => this.startTool('measurePolyLine')}
            iconStyling={"icon"}
            liClass={measurePolyLine}
            src={iconLinia}
          />
          <MenuIcon
            overlay={<Tooltip id="tooltip"><strong>{this.props.intl.langKeys.powierzchnia}</strong><br/>{this.props.intl.langKeys.pomPowierzchni}</Tooltip>}
            textPlacement="bottom"
            actionOnClick={() => this.startTool('measurePolygon')}
            iconStyling={"icon"}
            liClass={measurePolygon}
            src={iconPowierzchnia}
          />
          <MenuIcon
            overlay={<Tooltip id="tooltip"><strong>{this.props.intl.langKeys.wyczysc}</strong><br/>{this.props.intl.langKeys.wyczyscPom}</Tooltip>}
            textPlacement="bottom"
            actionOnClick={() => this.disableTool()}
            iconStyling={"glyphicon glyphicon-off"}
          />
        </ul>
      </div>
    );
  }
}

const mapState = (state) => ({
  district: state.district.district,
  tools: state.tools,
  intl: state.intl,
});

const mapDispatch = {
  disableMeasurementTool,
  setMeasurementTool,
};

export default withStyles(s, s1)(connect(mapState, mapDispatch)(MeasureTools));



// WEBPACK FOOTER //
// src/components/Modals/MeasureTools/MeasureTools.js